








































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import AccountState from '@/components/Accounts/Shared/AccountState.vue';

@Component({ name: 'ProductAccounts', components: { AccountState } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.products.fields.name'), sortable: false, width: '40%' },
        { text: this.$t('pageText.products.fields.productIssue'), sortable: false, width: '30%' },
        { text: this.$t('pageText.products.fields.createdAt'), sortable: false, width: '20%' },
        { text: this.$t('pageText.products.fields.state'), sortable: false, width: '10%' },
    ];
    productAccountsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.productAccountsPage = +page;
        }
    }

    async beforeMount() {
        await ProductDetailsModule.getProductAccounts(this.productAccountsPage);
    }

    @Watch('productAccountsPage')
    async onProductAccountsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.productAccountsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.productAccountsPage}` } });
        }
        // Get new product issue accounts
        await ProductDetailsModule.getProductAccounts(this.productAccountsPage);
    }

    get productAccounts() {
        return ProductDetailsModule.productAccounts;
    }

    get totalProductAccountsPages() {
        return ProductDetailsModule.totalProductAccountsPages;
    }

    get loading() {
        return ProductDetailsModule.loading;
    }

    get pageSize() {
        return ProductDetailsModule.pageSize;
    }

}
